export default {
    httpsUrl: 'https://pddata.xinkaipian.com/api',
    // httpsUrl: "/api",
    imgBeforeUrl:"https://pddata.xinkaipian.com",
    localKey: 'userID',
    mainAdminId: 'mainAdminId',  // 主账户ID
    superAdminId: 'superAdminId', // 超级管理员ID
    // 响应白名单接口
    responseWhiteApiList: ['/report/download']
};

